import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  fetchAdvertisementSuggestions,
  clearSuggestionDetails,
  selectData,
  selectIsLoading,
  selectSelectedSuggestion,
  selectSuggestionDetails,
  selectDetailsLoading,
  selectResponseType,
  fetchData,
  selectSuggestionsLoading,
  fetchSuggestions,
  setSuggestions,
  selectSuggestionsError,
  resetState,
  setChatbotId,
  selectUser,
  selectTilesDetails,
  selectRestrictedDataError,
  fetchSuggestionDetails,
  selectOpenAiTokens
} from "../../../../mainApp/features/DataSlice/dataSlice";
import {
  ChatbotContainer,
  ChatbotMain,
  ChatbotDetailsPanel,
  ChatbotForm,
  ChatbotButton,
  ChatbotExpandButton,
  ChatbotDetailsHeader,
  ChatbotError,
  ChatbotSuggestions,
  SuggestionsHeader,
  SuggestionsBox,
  SuggestionItem,
  SuggestionTitle,
  SuggestionDescription,
  ChatbotDetails,
  ChatbotMessage,
  AppTitle,
  LoadingElement,
  ChatbotTextarea,
  DocumentTypeSelector,
} from "../styled";
import LoadingPage from "../../TechnicalTabs/LoadingPage";
import ErrorPage from "../../../../mainApp/features/TechnicalTabs/ErrorPage";
import { auth, db } from "../../firebase";
import { doc, getDoc } from "firebase/firestore";
import { onAuthStateChanged } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { handleUnauthorizedAccess } from "../../Utility/handleUnauthorizedAccess";
import { ADVERTISEMENT_SUGGESTIONS_COST, ADVERTISEMENT_DETAILS_COST } from "../../Utility/tokenCosts";

const Advertisement = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isLoading = useSelector(selectIsLoading);
  const user = useSelector(selectUser);
  const tilesDetails = useSelector(selectTilesDetails);
  const restrictedDataError = useSelector(selectRestrictedDataError);
  const suggestionsLoading = useSelector(selectSuggestionsLoading);
  const suggestionsError = useSelector(selectSuggestionsError);
  const suggestions = useSelector(selectData);
  const selectedSuggestion = useSelector(selectSelectedSuggestion);
  const suggestionDetails = useSelector(selectSuggestionDetails);
  const detailsLoading = useSelector(selectDetailsLoading);
  const responseType = useSelector(selectResponseType);
  const currentTokens = useSelector(selectOpenAiTokens);

  const [platform, setPlatform] = useState("allegro");
  const [description, setDescription] = useState("");
  const [isDetailsExpanded, setIsDetailsExpanded] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);
  const [openAiTokens, setOpenAiTokensState] = useState(0);

  const validationToastId = 'advertisement-bot-validation-toast';

  const platforms = [
    { value: "allegro", label: "Allegro" },
    { value: "olx", label: "OLX" },
    { value: "oferteo", label: "Oferteo" },
    { value: "facebook", label: "Facebook Marketplace" },
    { value: "otodom", label: "Otodom" },
    { value: "otomoto", label: "Otomoto" },
  ];

  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  useEffect(() => {
    dispatch(setChatbotId("advertisement"));
    dispatch(clearSuggestionDetails());
    dispatch(resetState());
    dispatch(fetchData());

    return () => {
      dispatch(resetState());
    };
  }, [dispatch]);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        try {
          dispatch(fetchData());
          const ref = doc(db, "Users", currentUser.uid);
          const snap = await getDoc(ref);
          if (!snap.exists()) {
            console.warn("Dokument użytkownika nie istnieje.");
          }
          await delay(600);
        } catch (error) {
          console.error("Błąd pobierania danych użytkownika:", error);
          await delay(600);
        }
      } else {
        navigate("/login");
      }
      setInitialLoading(false);
    });

    return () => unsubscribe();
  }, [dispatch, navigate]);

  useEffect(() => {
    if (restrictedDataError) {
      navigate("/unauthorized");
    }
  }, [restrictedDataError, navigate]);

  useEffect(() => {
    if (currentTokens !== openAiTokens) {
      setOpenAiTokensState(currentTokens);
    }
  }, [currentTokens]);

  const handlePlatformChange = (e) => setPlatform(e.target.value);
  const handleDescriptionChange = (e) => setDescription(e.target.value);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!description.trim()) {
      dispatch(setSuggestions("Proszę podać szczegółowy opis produktu lub usługi."));
      return;
    }

    const toastOptions = {
      position: "top-center",
      toastId: validationToastId,
    };

    if (currentTokens < ADVERTISEMENT_SUGGESTIONS_COST) {
      toast.error("Masz za mało tokenów, aby wygenerować sugestie.", toastOptions);
      return;
    }

    dispatch(fetchSuggestions());
    dispatch({ type: "FETCH_ADVERTISEMENT_SUGGESTIONS", payload: { platform, description } });
    dispatch(clearSuggestionDetails());
  };

  const handleSuggestionClick = (index) => {
    const toastOptions = {
      position: "top-center",
      toastId: validationToastId,
    };

    if (currentTokens < ADVERTISEMENT_DETAILS_COST) {
      toast.error("Masz za mało tokenów, aby zobaczyć szczegóły.", toastOptions);
      return;
    }

    if (selectedSuggestion === index) {
      dispatch(clearSuggestionDetails());
    } else {
      dispatch(fetchSuggestionDetails({ index, platform, description }));
    }
  };

  const toggleDetailsPanel = () => setIsDetailsExpanded((prev) => !prev);

  if (initialLoading || isLoading === "loading") {
    return <LoadingPage />;
  }

  let returned;
  switch (isLoading) {
    case "success":
      if (!user) {
        returned = <LoadingPage />;
      } else if (tilesDetails.length > 0 && user) {
        returned = (
          <ChatbotContainer>
            <ChatbotMain
              isDetailsExpanded={isDetailsExpanded}
              isDetailsPanelVisible={selectedSuggestion !== null && suggestions.length > 0}
              isAdvertisement={true}
            >
              <AppTitle>Generator Ogłoszeń</AppTitle>

             <ChatbotForm onSubmit={handleSubmit} isAdvertisement={true}>
  <div>
    <DocumentTypeSelector
      value={platform}
      onChange={handlePlatformChange}
      isAdvertisement={true}
    >
      {platforms.map((p) => (
        <option key={p.value} value={p.value}>
          {p.label}
        </option>
      ))}
    </DocumentTypeSelector>

    <ChatbotButton type="submit" disabled={suggestionsLoading} isAdvertisement={true} tokenCost={ADVERTISEMENT_SUGGESTIONS_COST}>
      {suggestionsLoading ? "Generowanie..." : "Generuj ogłoszenia"}
    </ChatbotButton>
  </div>

  <ChatbotTextarea
    value={description}
    onChange={handleDescriptionChange}
    placeholder="Opisz szczegółowo co chcesz sprzedać lub jaką usługę oferujesz. Im więcej szczegółów, tym lepsze ogłoszenie zostanie wygenerowane..."
    isAdvertisement={true}
  />
</ChatbotForm>

              {suggestionsLoading ? (
                <LoadingElement isAdvertisement={true}>Generowanie ogłoszeń</LoadingElement>
              ) : suggestionsError ? (
                <ChatbotError isAdvertisement={true}>{suggestionsError}</ChatbotError>
              ) : suggestions && responseType === "message" ? (
                <ChatbotMessage isAdvertisement={true}>{suggestions}</ChatbotMessage>
              ) : Array.isArray(suggestions) && responseType === "suggestions" ? (
                <ChatbotSuggestions>
                  <SuggestionsHeader>Propozycje ogłoszeń:</SuggestionsHeader>
                  <SuggestionsBox>
                    {suggestions.map((suggestion, index) => (
                      <SuggestionItem
                        key={index}
                        onClick={() => handleSuggestionClick(index)}
                        isAdvertisement={true}
                        tokenCost={ADVERTISEMENT_DETAILS_COST}
                      >
                        <SuggestionTitle>{suggestion.title}</SuggestionTitle>
                        <SuggestionDescription>{suggestion.description}</SuggestionDescription>
                      </SuggestionItem>
                    ))}
                  </SuggestionsBox>
                </ChatbotSuggestions>
              ) : (
                <ChatbotMessage isAdvertisement={true}>
                  Brak ogłoszeń lub wystąpił błąd.
                </ChatbotMessage>
              )}
            </ChatbotMain>

            <ChatbotExpandButton
              onClick={toggleDetailsPanel}
              isDetailsExpanded={isDetailsExpanded}
              isAdvertisement={true}
            >
              {isDetailsExpanded ? "Zwiń szczegóły" : "Rozwiń szczegóły"}
            </ChatbotExpandButton>

            <ChatbotDetailsHeader
              isDetailsExpanded={isDetailsExpanded}
              isAdvertisement={true}
            />

            <ChatbotDetailsPanel
              isDetailsExpanded={isDetailsExpanded}
              isAdvertisement={true}
            >
              {selectedSuggestion !== null && suggestions.length > 0 ? (
                detailsLoading ? (
                  <LoadingElement>Generowanie szczegółowego ogłoszenia</LoadingElement>
                ) : suggestionDetails ? (
                  <ChatbotDetails isAdvertisement={true}>
                    <h2>{suggestions[selectedSuggestion].title}</h2>
                    {suggestionDetails.split("\n").map((line, i) => {
                      const cleanedLine = line.replace(/\*\*(.*?)\*\*/g, "$1");
                      const subheadingMatch = cleanedLine.match(/^(\d+\.\s)(.+)/);
                      const bulletMatch = cleanedLine.match(/^[-•*]\s(.+)/);

                      if (subheadingMatch) {
                        return (
                          <p key={i} className="subheading">
                            {cleanedLine}
                          </p>
                        );
                      } else if (bulletMatch) {
                        return (
                          <p key={i} className="bullet">
                            {cleanedLine}
                          </p>
                        );
                      }

                      return <p key={i}>{cleanedLine}</p>;
                    })}
                  </ChatbotDetails>
                ) : (
                  <ChatbotMessage isAdvertisement={true}>
                    Wystąpił błąd podczas ładowania szczegółów.
                  </ChatbotMessage>
                )
              ) : (
                <ChatbotMessage isAdvertisement={true}>
                  Wybierz ogłoszenie, aby zobaczyć szczegóły.
                </ChatbotMessage>
              )}
            </ChatbotDetailsPanel>
          </ChatbotContainer>
        );
      } else {
        returned = handleUnauthorizedAccess();
      }
      break;
    case "error":
      returned = <ErrorPage />;
      break;
    default:
      returned = <LoadingPage />;
  }

  return returned;
};

export default Advertisement;